import Vue from'vue';export default Vue.directive('img',{bind:function bind(el,binding,vnode,oldVnode){var exp=binding.expression;if(exp==='onloadstart'){binding.value(el)}if(exp==='onloadfinish'){if(el.complete){binding.value(el)}else{el.onload=function(){return binding.value(el)}}}}});


//////////////////
// WEBPACK FOOTER
// ./app/components/plugins/imgonload.js
// module id = 216
// module chunks = 0